/** Dashboard Tabs Component */

import React from 'react';
import { Tabs } from '@mantine/core';
import {
  IconLayoutDashboard,
  IconUsers,
  IconBrandCashapp,
  IconNetwork,
  IconShieldLock
} from '@tabler/icons-react';

/**
 * Dashboard Tabs - Main navigation tabs
 * 
 * Props:
 * - activeTab: string - Current active tab
 * - onTabChange: function - Tab change handler
 * - tabs: array - Tab definitions (optional, uses defaults)
 * - visibleTabs: array - Filter which tabs to show
 */
export const DashboardTabs = ({
  activeTab,
  onTabChange,
  tabs = null,
  visibleTabs = ['dashboard', 'users', 'clients', 'transactions', 'captive_portal']
}) => {
  const defaultTabs = [
    {
      value: 'dashboard',
      label: 'Dashboard',
      icon: <IconLayoutDashboard size={14} />
    },
    {
      value: 'users',
      label: 'Users',
      icon: <IconUsers size={14} />
    },
    {
      value: 'clients',
      label: 'Clients',
      icon: <IconBrandCashapp size={14} />
    },
    {
      value: 'transactions',
      label: 'Transactions',
      icon: <IconNetwork size={14} />
    },
    {
      value: 'captive_portal',
      label: 'Captive Portal',
      icon: <IconShieldLock size={14} />
    }
  ];

  const allTabs = tabs || defaultTabs;
  const filteredTabs = visibleTabs
    ? allTabs.filter(tab => visibleTabs.includes(tab.value))
    : allTabs;

  return (
    <Tabs value={activeTab} onTabChange={onTabChange}>
      <Tabs.List>
        {filteredTabs.map(tab => (
          <Tabs.Tab key={tab.value} value={tab.value} leftSection={tab.icon}>
            {tab.label}
          </Tabs.Tab>
        ))}
      </Tabs.List>
    </Tabs>
  );
};

export default DashboardTabs;
